import loggingService from '../util/loggingService'

var path = '/Lookup/'
var isDebug = false

function listLookup (http, type) {
    var route = type + '/List'
    loggingService.log(isDebug, 'Lookup service', 'Lookup on: ' + route)
    return http.get(path + route)
}

export default {
    listLookup: listLookup
}



// WEBPACK FOOTER //
// ./src/services/lookup/lookupService.js